import { render, staticRenderFns } from "./typeConfiguration.vue?vue&type=template&id=f3967e72&"
import script from "./typeConfiguration.vue?vue&type=script&lang=js&"
export * from "./typeConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./typeConfiguration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3967e72')) {
      api.createRecord('f3967e72', component.options)
    } else {
      api.reload('f3967e72', component.options)
    }
    module.hot.accept("./typeConfiguration.vue?vue&type=template&id=f3967e72&", function () {
      api.rerender('f3967e72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aymentsdk/typeConfiguration.vue"
export default component.exports